import { RudderAnalytics } from "@rudderstack/analytics-js"

const Rudderstack = new RudderAnalytics()

/**
 * Loads the Rudderstack SDK with the provided writeKey and dataPlaneUrl. It returns a promise
 * that fulfills when the SDK is ready, however, the SDK will queue calls before that
 * and execute them automatically so there's no need to await this promise.
 * @param {String} writeKey for the Rudderstack SDK
 * @param {String} dataPlaneUrl for the Rudderstack SDK
 * @returns {Promise<Rudderstack>}
 */
export const load = (writeKey, dataPlaneUrl) => {
  return new Promise(resolve => {
    Rudderstack.load(writeKey, dataPlaneUrl, {})

    Rudderstack.ready(() => {
      resolve(Rudderstack)
    })
  })
}

/**
 * Tracks an event with the provided properties. It adds the platform to the properties.
 * @param {String} eventName the event name
 * @param {Object} properties the event properties
 */
export const track = (eventName, properties = {}) => {
  Rudderstack.track(eventName, { ...properties, __platform: "landing-pages" })
}

/**
 * Fires a page view event with the provided page name.
 * @param {String} pageName
 */
export const page = (pageName) => {
  Rudderstack.page(pageName)
}

/**
 * Identifies a user with the provided userId and traits. This basically
 * creates a mapping from user id to anonymous id(s) which is useful to
 * associate a device to a user and be able to reconcile the journey later.
 *
 * @param userId
 * @param traits
 */
export const identify = (userId, traits) => {
  Rudderstack.identify(userId, traits)
}
